import { render, staticRenderFns } from "./TheDiscountCodeEdit.vue?vue&type=template&id=59a489bf&"
import script from "./TheDiscountCodeEdit.vue?vue&type=script&lang=ts&"
export * from "./TheDiscountCodeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a489bf')) {
      api.createRecord('59a489bf', component.options)
    } else {
      api.reload('59a489bf', component.options)
    }
    module.hot.accept("./TheDiscountCodeEdit.vue?vue&type=template&id=59a489bf&", function () {
      api.rerender('59a489bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheDiscountCodeEdit.vue"
export default component.exports